import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const VIDEO_COMPONENT_TEST_NAME = 'Homepage_VideoComponent_May2025';

export const isVideoComponentTestVariant = (): boolean =>
    getAbTestV2(VIDEO_COMPONENT_TEST_NAME)?.variant === 'variant';
